module.exports = __webpack_public_path__ + "img/live_tv.a34a7ee.png";